/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// A $( document ).ready() block.
$( document ).ready(function() {
  
  // If on contact us page
  if (window.location.pathname.indexOf('/contact-us') !== -1)
  {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const body = urlParams.get('body');
  
    // If we get a ?body=something parameter in the url
    if(body)
    {
		// Fill the message body and set the class to filled
		$("#contact-form-message").val(body);
  		$('#contact-form-message').addClass('is-filled');
    }
  }
  
  function fillForm(e)
  {
    var products = document.getElementsByClassName('_product_link');
    var quantities = document.getElementsByClassName('_cart_page_quantity');
    var customer_cart_value = document.getElementById('_form_customer_cart');

    var value = "";
    for(var i = 0; i < products.length; i++)
      value += `${quantities.item(i).value} \"${products.item(i).innerText}\"\n`;
    
    customer_cart_value.value = value;
  }
  
  var form = document.getElementById('quote-form');
  if(form)
  {
     form.addEventListener("submit", fillForm);
  }

  
//    var txt = $('#search-bar');
//onsole.log(txt.val);
//  if(txt.val() == "")
//    txt.val("* " + txt.val());
//});

});